export default __webpack_public_path__ + "static/media/image03.1ef1def9.jpg";